import { render, staticRenderFns } from "./PriceAnalyticsPlugin.vue?vue&type=template&id=533ae905&scoped=true&"
import script from "./PriceAnalyticsPlugin.vue?vue&type=script&lang=js&"
export * from "./PriceAnalyticsPlugin.vue?vue&type=script&lang=js&"
import style0 from "./PriceAnalyticsPlugin.vue?vue&type=style&index=0&id=533ae905&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ae905",
  null
  
)

export default component.exports